import 'url-search-params-polyfill';

export function getUrlParameter( name: string, queryString?: string) {
    const params = queryString ? 
        new URLSearchParams(queryString) : 
        new URLSearchParams(location.search);
    const value = params.get(name);
    return value != null ? value : "";
};